import React, { useEffect } from "react";

// SAVE YOUR TASTE — value-first, minimum-friction identity. Shown only AFTER a
// user has a Profile/Keepers payoff. One-tap Google via Emergent Managed Auth;
// no passwords, no intake, no onboarding. "Not now" always available.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Single source of truth for the Emergent Managed Auth redirect. Used for both
// SAVE YOUR TASTE (new-user signup) and returning-user LOG IN — the provider
// upserts by email, so the same one-tap flow serves signup and login.
export function startEmergentLogin() {
  // Return to the exact origin the user is on; boot detects #session_id.
  const redirectUrl = window.location.origin + "/";
  window.location.href =
    "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
}

export default function SaveTasteSheet({ open, onClose }) {
  // Escape closes on desktop — dismissal only. Declared before the early
  // return so the hook order stays stable.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const continueWithGoogle = () => {
    startEmergentLogin();
  };

  return (
    <div
      data-testid="save-taste-sheet"
      className="fixed inset-0 z-50 flex items-end justify-center p-3 sm:items-end sm:justify-end sm:p-8 bg-black/45 backdrop-blur-[3px]"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="relative w-full max-w-[460px] rounded-3xl bg-[#0c0d12] border border-white/12 p-6 shadow-[0_28px_90px_rgba(0,0,0,0.62)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-px w-full mb-5" style={{ background: "linear-gradient(90deg,var(--tt-left),var(--tt-right))", opacity: 0.7 }} />
        <h2 className="font-display font-black uppercase tracking-[-0.01em] text-bone text-2xl text-center">
          Save your taste
        </h2>
        <p className="mt-2 font-body text-[13px] text-silver text-center">
          Keep your Profile and Keepers across devices.
        </p>

        <button
          type="button"
          data-testid="continue-google"
          onClick={continueWithGoogle}
          className="mt-6 w-full flex items-center justify-center gap-3 rounded-full bg-bone text-[#0c0d12] py-3.5 font-display font-bold text-sm hover:opacity-90 transition-opacity"
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
            <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.6 9.5 24 9.5z" />
            <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4.1 7.1-10.1 7.1-17.5z" />
            <path fill="#FBBC05" d="M10.4 28.7c-.5-1.4-.7-2.9-.7-4.7s.3-3.3.7-4.7l-7.8-6.1C.9 16.5 0 20.1 0 24s.9 7.5 2.6 10.8l7.8-6.1z" />
            <path fill="#34A853" d="M24 48c6.2 0 11.4-2 15.2-5.5l-7.5-5.8c-2 1.4-4.7 2.3-7.7 2.3-6.4 0-11.7-3.7-13.6-8.9l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
          </svg>
          Continue with Google
        </button>

        <p className="mt-3 text-center font-body text-[11px] text-white/45">
          Already have an account?{" "}
          <button
            type="button"
            data-testid="save-taste-login"
            onClick={continueWithGoogle}
            className="underline underline-offset-2 text-white/65 hover:text-white transition-colors"
          >
            Log in
          </button>
        </p>

        <button
          type="button"
          data-testid="save-taste-notnow"
          onClick={onClose}
          className="mt-3 w-full text-center font-body font-medium text-[11px] tracking-[0.2em] uppercase text-white/45 hover:text-white/75"
        >
          Not now
        </button>
      </div>
    </div>
  );
}
